import React, { useState } from 'react';

const SubscriptionForm = ({ className }) => {
  const [status, setStatus] = useState(null);
  const FORM_ID = "2922262";
  const FORM_URL = `https://app.convertkit.com/forms/${FORM_ID}/subscriptions`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);

    try {
      const response = await fetch(
        FORM_URL,
        {
          method: "post",
          body: data,
          headers: {
            accept: "application/json",
          },
        }
      );

      const json = await response.json();

      if (json.status === "success") {
        setStatus("SUCCESS");
        return;
      }

      setStatus("ERROR");
    } catch (err) {
      setStatus("ERROR");
    }
  }

  return (
    <div className={`space-y-2 ${className}`}>
      <h3 className="text-center text-md md:text-lg text-gray-600">
        Subscribe to receive new post previews, ideas,<br/>and tips & tricks in your inbox.
      </h3>

      { status === 'ERROR' && <p className="text-center text-lg text-red-700">Oops, something went wrong! Please, try again.</p> }

      { status === "SUCCESS" ?
        <p className="text-center text-lg text-blue-600">
          Success! We've sent you an email to confirm your subscription.
        </p>
      :
        <form
          action={FORM_URL}
          method="post"
          onSubmit={handleSubmit}
          className="sm:flex sm:items-center justify-center"
        >
          <div className="w-full sm:max-w-xs">
            <label htmlFor="email" className="sr-only">
              Email
            </label>
            <input
              className="shadow-sm focus:ring-indigo-500 focus:border-red-500 block w-full sm:text-sm border-gray-300 rounded-md"
              type="email"
              aria-label="Your email"
              name="email_address"
              placeholder="Your email address"
              required
            />
          </div>
          <button
            className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-red-700 hover:text-red-800 bg-red-200 hover:bg-red-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            type="submit"
          >
            Subscribe
          </button>
        </form>
      }
    </div>
  );
}

export default SubscriptionForm
